export default {
  FORFAIT: {
    HEURES: 'Hours Package',
    JOURS: 'Days Package',
  },
}
